import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { QcResponsibleAssignments } from 'src/models';

@Component({
  selector: 'app-qc-responsible-assignments',
  templateUrl: './qc-responsible-assignments.component.html',
  styleUrls: ['./qc-responsible-assignments.component.css']
})
export class QcResponsibleAssignmentsComponent implements OnInit {

tablePermissions: AimsCommonTablePermissions = {
    create: this.permissions.canCreate(this.permissions.ComponentID.QualityControlConfig),
    update: this.permissions.canUpdate(this.permissions.ComponentID.QualityControlConfig),
    delete: false,
  };
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'responsibleAssignment', label: 'Responsible Assignment', type: 'string', width: 300, validatorOrOpts: [Validators.required, Validators.maxLength(50)] },
    { key: 'active', label: 'Active', type: 'boolean', filterType: 'boolean' },
  ];

  defaultItem: QcResponsibleAssignments = this.newResponsibleAssignment();
  newResponsibleAssignment() {
    let retVal = new QcResponsibleAssignments();
    retVal.active = true;
    return retVal;
  }

  constructor(private transferHttp: TransferHttpService,public permissions: PermissionsService) { }

  responsibleAssignments;

  public handleRowUpdate(update: TableRowUpdate): void {
    const updatedLineItem: QcResponsibleAssignments = update.newRow as QcResponsibleAssignments;
    this.saveItem(updatedLineItem);
  }

  public handleRowAdded(update: TableRowUpdate) {
    const item: QcResponsibleAssignments = update.newRow as QcResponsibleAssignments;
    this.saveItem(item);
  }

  public handleRowDelete(deleted: TableRowDelete) {
  }

  saveItem(item) {
    this.transferHttp.save('QualityControl/SaveResponsibleAssignments', item, false).subscribe(show => {
      if (!show) {
        this.loadItems();
      }
    });
  }

  loadItems() {
    this.responsibleAssignments = this.transferHttp.getSingle('QualityControl/GetResponsibleAssignments');
  }

  ngOnInit(): void {
    this.loadItems();
  }

}
